export default __webpack_public_path__ + "static/media/playerDeath.1dacbc8d.wav";